'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _formLabel = require('../formLabel');

var _input = require('../input');

require('./input-group.scss');

require('./input-group-addon.scss');

require('./input-group-floating.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Check if a value is valid to be displayed inside an input.
 * @param {string} value The value to check.
 * @returns {boolean} True if the string provided is valid, false otherwise.
 */
var inputValueIsValid = function inputValueIsValid(value) {
    return value !== '' && value !== null;
};

/**
 * WH InputGroup Component
 * @param {Event} event onChange event handler
 * @returns {ReactElement} The react component to the input group
 * @constructor
 */

// css

// components

var InputGroup = function (_Component) {
    (0, _inherits3.default)(InputGroup, _Component);

    function InputGroup(props) {
        (0, _classCallCheck3.default)(this, InputGroup);

        var _this = (0, _possibleConstructorReturn3.default)(this, (InputGroup.__proto__ || (0, _getPrototypeOf2.default)(InputGroup)).call(this, props));

        _this.handleOnFocus = function () {
            var _this$props$onFocus = _this.props.onFocus,
                onFocus = _this$props$onFocus === undefined ? function () {} : _this$props$onFocus;

            _this.setState({
                isFocused: true
            });

            onFocus();
        };

        _this.handleOnBlur = function () {
            var _this$props$onBlur = _this.props.onBlur,
                onBlur = _this$props$onBlur === undefined ? function () {} : _this$props$onBlur;

            _this.setState({
                isFocused: false
            });

            onBlur();
        };

        _this.handleOnChange = function (event) {
            var _this$props$onChange = _this.props.onChange,
                onChange = _this$props$onChange === undefined ? function () {} : _this$props$onChange;


            if (event.target && event.target.value) {
                _this.setState({
                    hasValue: inputValueIsValid(event.target.value)
                });
            }

            onChange();
        };

        _this.state = {
            isFocused: false,
            hasValue: false
        };
        return _this;
    }

    (0, _createClass3.default)(InputGroup, [{
        key: 'renderHintText',
        value: function renderHintText() {
            var hintText = this.props.hintText;


            var hintClassName = (0, _classnames2.default)({
                'sb-input-hint': true,
                'sb-input-hint--show': this.state.isFocused
            });

            if (hintText) {
                return (0, _jsx3.default)('p', {
                    className: hintClassName
                }, void 0, hintText);
            }

            return null;
        }
    }, {
        key: 'renderErrorText',
        value: function renderErrorText() {
            var errorText = this.props.errorText;


            if (errorText) {
                return (0, _jsx3.default)('p', {
                    className: 'sb-input-error'
                }, void 0, errorText);
            }

            return null;
        }
    }, {
        key: 'renderFormLabel',
        value: function renderFormLabel() {
            var _props = this.props,
                _props$id = _props.id,
                id = _props$id === undefined ? '' : _props$id,
                label = _props.label;


            if (label) {
                return (0, _jsx3.default)(_formLabel.FormLabel, {
                    htmlFor: id
                }, void 0, label);
            }

            return null;
        }
    }, {
        key: 'renderInput',
        value: function renderInput(props) {
            var inputClassName = props.inputClassName;


            return _react2.default.createElement(_input.Input, (0, _extends3.default)({}, props, {
                className: inputClassName,
                onFocus: this.handleOnFocus,
                onChange: this.handleOnChange,
                onBlur: this.handleOnBlur
            }));
        }
    }, {
        key: 'render',
        value: function render() {
            var _cx;

            var _props2 = this.props,
                _props2$className = _props2.className,
                className = _props2$className === undefined ? '' : _props2$className,
                _props2$inputStyle = _props2.inputStyle,
                inputStyle = _props2$inputStyle === undefined ? '' : _props2$inputStyle,
                _props2$isDisabled = _props2.isDisabled,
                isDisabled = _props2$isDisabled === undefined ? false : _props2$isDisabled,
                _props2$isValid = _props2.isValid,
                isValid = _props2$isValid === undefined ? false : _props2$isValid,
                _props2$hasErrors = _props2.hasErrors,
                hasErrors = _props2$hasErrors === undefined ? false : _props2$hasErrors;


            var classNames = (0, _classnames2.default)((_cx = {
                'sb-input-group': true,
                'sb-input-group--success': isValid,
                'sb-input-group--error': hasErrors,
                'sb-input-group--focus': this.state.isFocused,
                'sb-input-group--hasValue': this.state.hasValue,
                'sb-input-group--disabled': isDisabled
            }, (0, _defineProperty3.default)(_cx, 'sb-input-group--' + inputStyle, inputStyle), (0, _defineProperty3.default)(_cx, '' + className, className), _cx));

            return (0, _jsx3.default)('div', {
                className: classNames
            }, void 0, this.renderFormLabel(), this.renderInput(this.props), this.renderHintText(), this.renderErrorText());
        }
    }]);
    return InputGroup;
}(_react.Component);

exports.default = InputGroup;
//# sourceMappingURL=InputGroup.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/inputGroup/InputGroup.js
// module id = 562
// module chunks = 0